import React from 'react';
const STEPS = [{
  n: 'i',
  title: 'Pago seguro',
  desc: 'Checkout vía Shopify. Tarjeta o Apple Pay.',
  time: 'Segundos'
}, {
  n: 'ii',
  title: 'Bundle en tu correo',
  desc: 'Los 4 recursos llegan al email con el que compraste.',
  time: '< 5 minutos'
}, {
  n: 'iii',
  title: 'Lectura completa',
  desc: 'Recorres el método A.R.M.O.N.Y. de principio a fin.',
  time: '~ 90 minutos'
}, {
  n: 'iv',
  title: 'Llegas a tu consulta',
  desc: 'Con claridad, criterio y las preguntas correctas.',
  time: 'Cuando estés lista'
}];
export function HowItWorks() {
  return <section className="section" data-id="element-58">
      <header className="howit-header" data-id="element-59">
        <span className="eyebrow" data-id="element-60">Qué sigue después del click</span>
        <h2 className="section-h2 section-h2--center" data-id="element-61">
          Acceso en menos de cinco minutos.
        </h2>
      </header>

      <ol className="howit-list" data-id="element-62">
        {STEPS.map(s => <li key={s.n} className="howit-item" data-id="element-63">
            <span className="howit-num" data-id="element-64">{s.n}</span>
            <div className="howit-body" data-id="element-65">
              <h3 className="howit-title" data-id="element-66">{s.title}</h3>
              <p className="howit-desc" data-id="element-67">{s.desc}</p>
              <span className="howit-time" data-id="element-68">{s.time}</span>
            </div>
          </li>)}
      </ol>
    </section>;
}